import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table } from 'antd';

import { convertirTextAMomentLocal } from '../../commons/gestioDates';
import { avisVisualitzacioSeleccionarAvis } from '../../actions/avis';
import obtenirLlistatAvisosFiltratsPelMapa from '../../selectors/selector_avis_llista';
import icones from '../../images/avis';

const columns = [
    {
        title: 'Id Meteor',
        dataIndex: 'idMeteor',
        key: 'idMeteor',
        width: 44,
        render: idMeteor => <img alt='' src={icones[idMeteor]} />
    }, {
        title: 'Municipi',
        dataIndex: 'nomMunicipi',
        key: 'nomMunicipi'
    }, {
        title: 'Data',
        dataIndex: 'data',
        key: 'data',
        width: 110,
        render: data => data.format('DD/MM/YYYY HH:mm')
    }
];

/*
 * Configuració de la paginació segons la resolució de la finestra
 * Si no hi ha la relació es retorna la configuració més petita (mòbil)
 ***/
const defaultCurrent = 1;
const hideOnSinglePage = true;
const propietatsPaginacioPerDefecte = {
    defaultCurrent,
    hideOnSinglePage,
    defaultPageSize: 3,
    pageSize: 3
};

// S'utilitza a la versió escriptori gran (menys height que a la mitjana)
const heightEspaiMitja = 250;
const propietatsPaginacioEspaiMitja = {
    ...propietatsPaginacioPerDefecte,
    defaultPageSize: 4,
    pageSize: 4
};

// S'utilitza a la versió escriptori mitja
const heightEspaiGran = 350;
const propietatsPaginacioEspaiGran = {
    ...propietatsPaginacioPerDefecte,
    defaultPageSize: 7,
    pageSize: 7
};

/**
 * Es crea l'estructura amb les dades que calen: id, idMeteor, data, codiIneMunicipi.
 * El idMeteor cal per la icona. El id de l'avís per poder cridar a avisVisualitzacioSeleccionarAvis
 * Finalment s'ordena per data. Primer la més recent.
 */
const obtenirEstructuraAvisosOrdenada = (avisos) => {
    return avisos
        .map((avis) => {
            const { id, idMeteor, data, municipi } = avis;
            const nomMunicipi = municipi.nom;
            return { id, idMeteor, data: convertirTextAMomentLocal(data), nomMunicipi };
        })
        .sort((avisA, avisB) => {
            // Segons la implementació de Array.sort(), s'ha de retornar -N, N o 0 depenent de
            // com es vulgui ordenar el valor A respecte el valor B, on N és qualsevol valor numèric
            return avisB.data.diff(avisA.data, 'minute');
        });
};

class AvisLlista extends Component {

    constructor(props) {
        super(props);
        this.state = { height: 0 };
        this.handleResize = this.handleResize.bind(this);
    }

    handleResize() {
        const { height } = this.state;
        const currentHeight = window.getComputedStyle(this.avisLlista)['height'];

        if (height !== currentHeight) {
            const novaHeight = parseInt(currentHeight.replace('px', ''), 10);
            this.setState({ height: novaHeight });
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    calcularPropietatsPaginacio() {
        switch (this.state.height) {
            case heightEspaiGran:
                return propietatsPaginacioEspaiGran;
            case heightEspaiMitja:
                return propietatsPaginacioEspaiMitja;
            default:
                return propietatsPaginacioPerDefecte;
        }
    }

    render() {
        const { avisos } = this.props;
        const { avisVisualitzacioSeleccionarAvis } = this.props;
        const avisosFiltratsPelMapa = obtenirEstructuraAvisosOrdenada(avisos);
        const propietatsPaginacio = this.calcularPropietatsPaginacio();

        return <div
            className='avis-llista'
            ref={ref => this.avisLlista = ref}>
            <Table
                locale={{emptyText: 'No hi ha avisos'}}
                dataSource={avisosFiltratsPelMapa}
                columns={columns}
                size='small'
                pagination={propietatsPaginacio}
                showHeader={false}
                rowKey={avis => avis.id}
                onRow={(record) => ({
                    onClick: () => { avisVisualitzacioSeleccionarAvis(record.id); }
                })}
            />
        </div>;
    }
}

AvisLlista.propTypes = {
    avisos: PropTypes.array.isRequired,
    avisVisualitzacioSeleccionarAvis: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return {
        avisos: obtenirLlistatAvisosFiltratsPelMapa(state)
    };
};

export default connect(mapStateToProps, { avisVisualitzacioSeleccionarAvis })(AvisLlista);



// WEBPACK FOOTER //
// ./src/components/avis/avisLlista.js